import { Action } from '@ngrx/store';
import { AnnuitantMedicalConditions } from '../../model/lifestyle.post.model';
import * as LifestyleResultActions from '../actions/lifestyle.action';

export type Actions = LifestyleResultActions.Actions;

export function LifestyleReducer(state: AnnuitantMedicalConditions[] = [],
    action: LifestyleResultActions.Actions) {
    switch (action.type) {
        case LifestyleResultActions.ADD_LIFESTYLE_RESULT:
            return [...state, action.payload];

        // Add this case:
        case LifestyleResultActions.REMOVE_LIFESTYLE_RESULT:
            state = [];
            return state;
        default:
            return state;
    }
}

